import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Eyebrow, PillButton } from "../ui";
import { paths } from "../../routes/paths";
import { tokens } from "../../styles/tokens";

/**
 * The home hero. Registration is the app's primary job, so it gets the page's
 * only H1 and the only amber CTA above the fold.
 */
const RegisterHero: FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderBottom: `1px solid ${tokens.color.hairline}`,
      }}
    >
      <Box
        sx={{
          width: `min(100%, ${tokens.space.containerMax}px)`,
          mx: "auto",
          px: { mobile: 2.5, tablet: 4, laptop: 5 },
          py: { mobile: 5, laptop: 8 },
          maxWidth: 900,
        }}
      >
        <Eyebrow>Installer portal</Eyebrow>
        <Typography variant="h1" sx={{ mb: 2 }}>
          Register a product.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 4, maxWidth: 620 }}>
          Register the warranty for an Artome device you have installed. It takes
          about a minute — you will need the Artome and projector serial numbers.
        </Typography>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          <PillButton
            tone="amber"
            withArrow
            onClick={() => navigate(paths.registerSerial)}
          >
            Register a product
          </PillButton>
          <PillButton tone="outline" onClick={() => navigate(paths.guides)}>
            Installation guides
          </PillButton>
        </Box>
      </Box>
    </Box>
  );
};

export default RegisterHero;
